<template>
  <div class="d-flex justify-content-center" id="modal-reactivate-user">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="m-portlet__head modal-reactivate-user-title">
          <h3 class="m-portlet__head-text">{{$t("message.ob_reactivate_user")}}</h3>
        </div>
        <hr class="w-100 mt-0 mb-0"/>
        <form name="form.resetPass" action  @submit.prevent="reactivateUser">
          <div class="reactivate-user-container row">
            <div class="col-12 group-inputs-label">
              <datepicker
                  data-vs-datepicker="picker-contract"
                  @cleared = "formInfo.fecha_contratacion = ''"
                  :language="es"
                  name="fecha_contratacion"
                  id="fecha_contratacion"
                  format="dd/MM/yyyy"
                  :bootstrap-styling="true"
                  clear-button-icon="fa fa-times"
                  :clear-button="true"
                  v-model="formInfo.fecha_contratacion"
                  input-class="input-datepicker"
                  @closed="onTouchDate"
              ></datepicker>
              <div class="col-12" v-if="this.unsubscribeDate != '---'">
                <span class="required_style">*</span>
                <small class="message-legend-has-license">{{$t('message.ob_reactivate_user_date_note')}} ({{this.unsubscribeDate}})</small>
              </div>
              <label
                  class="ml-2 label_styles_date"
                  :class="[(startDateTexting) ? 'elevateLabel' : '']"
              >
                {{$t("message.userActive.fecha_contratacion")}}
              </label>
              <label class="is-invalid-date" v-show="isInvalidDate">{{ $t('message.ob_reactive_user_not_date') }}</label>
            </div>
            <div class="col-12 group-inputs-label">
              <div class="group-reset-mail">
                <input class="reset-mail-input" type="text" v-validate="'email'" data-vs-input="reset-email-input"
                       name="mail" v-model="email" placeholder=" ">
                <span class="highlight"></span>
                <span class="bar mt-1"></span>
                <label class="reset-mail-label">{{$t("message.ei_titleList_text_2_2")}}</label>
              </div>
              <div>
                <p class="m--font-danger" v-for="error in errors.collect('mail')">{{ error }}</p>
              </div>
            </div>
            <div class="col-12 group-inputs-label" v-if="hasOnBoardingPermission">
              <label class="ml-2 typo__label font-weight-normal">{{ $t('message.ob_title_list') }}</label>
              <multi-select
                  data-vs-multiselect="section-select"
                  v-model="sectionSelected" :options="reduceTemplateList" :searchable="true" :close-on-select="true"
                  :taggable="true" :tag-placeholder="$t('message.ob_title_list')"
                  :placeholder="$t('message.ob_select_template')" :show-labels="false" label="nombre" >
                <template slot="noResult">
                  <span
                      class="multiselect__single">{{$t('message.userActive.error_sector_not_found') }}
                  </span>
                </template>
              </multi-select>
            </div>
            <div class="col-12 group-inputs-label" v-if="hasIntengrationSichernPeople && hasOnBoardingPermission">
              <label class="ml-2 typo__label font-weight-normal">{{ $t('message.ob_title_model_list') }}</label>
              <multi-select
                  data-vs-multiselect="integration-model-select"
                  v-model="integrationModelSelected" :options="integrationModels" :searchable="true" :close-on-select="true"
                  :taggable="true" :tag-placeholder="$t('message.ob_title_model_list')"
                  :placeholder="$t('message.ob_select_model_organization')" :show-labels="false" label="description">
                <template slot="noResult">
                  <span
                      class="multiselect__single">{{$t('message.userActive.error_organization_model_not_found') }}
                  </span>
                </template>
              </multi-select>
            </div>
            <div class="col-12 group-inputs-label" v-if="hasLicenses">
              <span class="required_style">*</span>
              <div class="message-legend-has-license">{{ $t('message.ob_reactivate_user_with_license') }}</div>
            </div>
          </div>
          <div class="d-flex m-3 h-12">
            <button data-vs-button="clear-fields" type="button" @click="clearFields" data-dismiss="modal" class="btn btn-secondary mr-3 w-100">{{$t("message.cancel")}}</button>
            <button data-vs-button="confirm" v-if="!loadingReactivate" :disabled="errors.any()" type="submit" class="btn btn-primary w-100">{{$t("message.employee_confirm")}}</button>
            <button data-vs-button="submit" v-if="loadingReactivate" type="submit" class="btn btn-primary w-100">
              <div class="m-loader m-loader--light"></div>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import datepicker from "vuejs-datepicker";
import MultiSelect from 'vue-multiselect';
import {es} from "vuejs-datepicker/dist/locale";
import {mapGetters, mapActions} from 'vuex'
import _ from "underscore";
import moment from 'moment'
import swal from "sweetalert2";
import OnBoarding from "@/apiClient/OnBoarding";
import SichernIntegration from '@/apiClient/SichernIntegration';


export default {
  name: "ReactivateUser",
  components: {
    datepicker,
    MultiSelect
  },
  props: ["templateId", "setTemplateChanged", "unsubscribeDate"],
  created() {
    this.testIntegration =new SichernIntegration();
    this.checkActiveSichernPeopleIntegration();
    this.getSichernPeopleOrganizationModels();
  },
  data() {
    return {
      es: es,
      formInfo: {
        fecha_contratacion: ""
      },
      formInfoRequires: {
        fecha_contratacion: {}
      },
      startDateTexting: false,
      sectionSelected: '',
      isTouchedDate: false,
      loadingReactivate: false,
      isSuccessReactiveUser: false,
      hasIntengrationSichernPeople: false,
      integrationModelSelected: '',
      integrationModels: [],
      email: ''
    }
  },
  methods: {
    ...mapActions({ setReactivateUser:'setReactivateUser' }),
    clearFields() {
      this.formInfo.fecha_contratacion = '';
      this.isTouchedDate = false;
      this.integrationModelSelected = '';
      this.sectionSelected = '';
      this.email = '';
    },
    async reactivateUser() {
      let data = {
        idUser: this.$route.params.id,
        email: this.email,
        recruitmentDate: moment(this.formInfo.fecha_contratacion).format('DD/MM/YYYY')
      };
      this.hasIntengrationSichernPeople ? data.organizationModel = this.integrationModelSelected.id : ''
      if(this.formInfo.fecha_contratacion) {
        this.loadingReactivate = true;
        this.setReactivateUser(data).then( response => {
          this.isSuccessReactiveUser = true;
          if(this.isSuccessReactiveUser && this.sectionSelected) {
            const ob = new OnBoarding();
            ob.onBoardingReactivate(this.$route.params.id, this.sectionSelected.id, 1).then( response => {
              this.showSwal();
              this.isSuccessReactiveUser = false;
              this.setTemplateChanged(true);
            }).catch((e) => {
              this.isResponseErrorMessage(e);
            });
          }
          else{
            this.showSwal();
          }
        }).catch((e) => {
          this.isResponseErrorMessage(e);
        });

      } else {
        this.isTouchedDate = true
      }
    },
    showSwal(){
      this.loadingReactivate = false;

      swal({
        title: this.$t("message.ob_reactivate_user_success").toString(),
        reverseButtons: false,
        type: "success",
        confirmButtonColor: "#0091b0",
        confirmButtonText: this.$t("message.employee_confirm").toString()
      }).then(() => {
        this.clearFields();
        this.$emit('isReactivateUser');
        $('#reactivateUser').modal('hide')
      })
    },
    onTouchDate() {
      this.isTouchedDate = true
    },
    isResponseErrorMessage(errors) {
      let errorStr = `${this.$t("message.employee_edit_error")}`;

      if (errors.hasOwnProperty("codes")){
        errorStr = this.$t("message.error_"+errors.codes[0].code);
      }
      else if (errors.hasOwnProperty("code")) {
        errorStr =  errors.code === '00129' ? `${this.$t("message.ob_reactive_user_email_exists")}` : this.$t("message.error_"+errors.code);
      }

      this.loadingReactivate = false;

      swal({
        type: "error",
        title: `${this.$t("message.actions.error")}`,
        text: errorStr,
        showConfirmButton: true,
        confirmButtonText: `${this.$t(
            "message.employee_confirm"
        )}`
      });
    },
    async checkActiveSichernPeopleIntegration() {
      const type = 'VP_ONBOARDING'
      const { data } = (await this.testIntegration.checkIntegrationSichernPeopleByType(type)).data;
      this.hasIntengrationSichernPeople = data.enabled;
    },

    async getSichernPeopleOrganizationModels() {
      const { data } = (await this.testIntegration.getSichernPeopleOrganizationModel()).data;
      this.integrationModels = data;
    }
  },
  watch: {
    "formInfo.fecha_contratacion": function(val) {
      this.startDateTexting = this.formInfo.fecha_contratacion !== "";
    }
  },
  computed: {
    ...mapGetters({ getActions : 'getActions', getCleanAction : 'getCleanAction' }),
    reduceTemplateList() {
      return _.filter(
          this.$store.state.onBoardingList,
          template => {
            return template.activo=="true";
          }
      );
    },
    hasOnBoardingPermission() {
      const numbers = ['73', '74'];
      const containsNumbers = this.getCleanAction.some(number => numbers.includes(number));
      return containsNumbers;
    },

    hasLicenses() {
      let temp = _.find(this.getActions, (val, key) => {
        return _.some(val, item => {
          return item.id === '71'
        })
      });
      return _.some(temp, el => {
        return el.id === '71'
      })
    },
    isInvalidDate() {
      return this.isTouchedDate && this.formInfo.fecha_contratacion.length === 0
    }
  }
}
</script>

<style scoped lang="scss">
@import "./public/assets/scss/_config.scss";
@import "./public/assets/scss/components/_resetpass.scss";
.modal-dialog {
  width: 500px;
  margin: 1.75rem auto;
}
.modal-content {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #FFF;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: .3rem;
  outline: 0;
}
.modal-reactivate-user-title {
  display: flex;
  font-size: 20px ;
  font-family: Roboto;
  font-style: normal ;
  font-weight: normal ;
  justify-content: flex-start;
}
.reactivate-user-container {
  padding: 0.5em;
}
.label_styles_date {
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.elevateLabel{
  top:-20px !important;
}
.required_style {
  color: $buttonPrimary;
  width: 6px;
  margin-right: 5px;
  display: inline-block;
  vertical-align: top;
}
.message-legend-has-license {
  width: 97%;
  display: inline-block;
}
.group-inputs-label {
  margin: 25px 0px 2px 0px;
  padding: 0 30px;
}
.select-editable{
  input{
    width: 100%;
    position: absolute;
    top: -2px;
    border: none;
  }
}
.is-invalid-date {
  color: $buttonPrimary;
}

.reset-mail-input {
  border-bottom: 1px solid $gray;
}
.reset-mail-label {
  color: $black;
  font-size: 14px;
}
.reset-mail-input:focus~.reset-mail-label,
.reset-mail-input:valid~.reset-mail-label {
  color: $black;
}

</style>